const headlinesList = document.querySelector('.headlines-list');
const tp = document.querySelector('#tp');
async function getNews() {
    try {
        const rawNews = await fetch(' https://newsdata.io/api/1/latest?apikey=pub_ae2c1e5d72324380a780b1a25680f4bc&q=pizza');
        const jsonNews = await rawNews.json();
        console.log(jsonNews);
        if (!jsonNews.results.length > 0) throw new Error('could not get the news');
        return jsonNews.results;
    } catch (error) {
        renderError(error);
    }
}
async function render() {
    try {
        const news = await getNews();
        if (!news) return;
        const markup = news.map((element)=>{
            return `<li>
          <img src="${element.image_url}" alt="">
         <a href="${element.url}" class="link">${element.title}</a>
         <p> ${element.description}</p>
         
         </li>`;
        }).join('');
        headlinesList.innerHTML = '';
        headlinesList.innerHTML = markup;
    } catch (error) {
        console.log(error);
    }
}
function getTime() {
    const time = new Date();
    const hour = time.getHours();
    const minute = time.getMinutes();
    const seconds = time.getSeconds();
    return `${hour} : ${minute} : ${seconds}`;
}
function renderTime() {
    tp.innerText = '';
    tp.innerText = ` today's weather is and time is : ${getTime()} `;
}
function renderError(msg) {
    headlinesList.innerHTML = '';
    const markup = `<li>
          <img src="" alt="">
         <a href="#" class="link">${msg}</a>
         <p> </p>
         
         </li>`;
    headlinesList.innerHTML = markup;
}
setInterval(renderTime, 1000);
const init = function() {
    render();
};
init();

//# sourceMappingURL=whatsnews.6056d01f.js.map
